<template>
  <div class="circular-progress" :style="{ '--normalizedPercent': normalizedPercent + 'deg' }"></div>
</template>
<script>
export default {
  props: {
    percent: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    normalizedPercent: function () {
      return (this.percent / 100) * 180;
    },
  },
};
</script>
<style lang="scss" scoped>
.circular-progress {
  --normalizedPercent: 0;
  &,
  &:before,
  &:after {
    width: 12rem;
    height: 12rem;
    border-radius: 50%;
  }
  margin: 0 auto -80px auto;
  z-index: -1;
  position: relative;
  transform: rotate(var(--normalizedPercent));
  &:before,
  &:after {
    position: absolute;
    top: 0;
    left: 0;
    // color del texto
    text-align: center;
  }
  &:before {
    content: attr(data-value);
    background: #fff content-box;
    padding: 0.5em;
    box-sizing: border-box;
    font-size: 1.3rem;
    line-height: 5rem;
    transform: rotate(calc(var(--normalizedPercent) * -1));
    color: #6c757d;
  }
  &:after {
    content: attr(data-percent);
    background: linear-gradient(transparent 50%, #fff 50%);
    transform: scale(1.1) rotate(calc(var(--normalizedPercent) * -1));
    line-height: 10.5rem;
    font-size: 30px;
    color: orange;
  }
  &.Pk {
    background: linear-gradient(0deg, orange 50%, rgba($color: orange, $alpha: 0.2) 50%);
  }
  &.Tk {
    background: linear-gradient(0deg, #2693fc 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Math,
  &.Matemáticas {
    background: linear-gradient(0deg, #2693fc 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Grammar,
  &.Gramática {
    background: linear-gradient(0deg, #f4cf14 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Reading,
  &.Lectura.y.comprensión {
    background: linear-gradient(0deg, #f50c0d 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Science,
  &.Ciencias {
    background: linear-gradient(0deg, #b51da3 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Social.Studies,
  &.Ciencias.sociales {
    background: linear-gradient(0deg, #2aaf0a 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Vocabulary,
  &.Vocabulario {
    background: linear-gradient(0deg, #ff790b 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.American.History {
    background: linear-gradient(0deg, #0052b7 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Biology {
    background: linear-gradient(0deg, #9ef835 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Chemistry {
    background: linear-gradient(0deg, #880b8b 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Physics {
    background: linear-gradient(0deg, #36c17d 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.World.Studies {
    background: linear-gradient(0deg, #932f1d 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.English.I,
  &.Inglés.I {
    background: linear-gradient(0deg, #2aaf0a 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.English.II,
  &.Inglés.II {
    background: linear-gradient(0deg, #932f1d 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.English.III,
  &.Inglés.III {
    background: linear-gradient(0deg, orange 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.English.IV,
  &.Inglés.IV {
    background: linear-gradient(0deg, #b51da3 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Government,
  &.Gobierno {
    background: linear-gradient(0deg, #0052b7 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Algebra {
    background: linear-gradient(0deg, #932f1d 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Calculus,
  &.Cálculo {
    background: linear-gradient(0deg, #9ef835 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Differential.Calculus,
  &.Cálculo.Diferencial {
    background: linear-gradient(0deg, orange 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Integral.Calculus,
  &.Cálculo.Integral {
    background: linear-gradient(0deg, #932f1d 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Lógica.Matemática,
  &.Mathematical.Logic {
    background: linear-gradient(0deg, #b51da3 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Aritmética,
  &.Arithmetic {
    background: linear-gradient(0deg, #0052b7 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Analytic.Geometry,
  &.Geometría.Analítica {
    background: linear-gradient(0deg, #932f1d 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Geometry,
  &.Geometría {
    background: linear-gradient(0deg, #0052b7 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
  &.Trigonometry,
  &.Trigonometría {
    background: linear-gradient(0deg, #880b8b 50%, rgba($color: #1a577d, $alpha: 0.2) 50%);
  }
}
</style>
